export enum Weekdays {
  SUNDAY = 'SUNDAY',
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
}

export const weekdaysFromString = (value: string[]): Weekdays[] => {
  return value.map((v) => weekdayFromString(v));
};

/**
 * Convert a string value into an instance of the Weekdays enum.
 * TODO: remove the german entries and fix the freakin faulty forms instead!
 * @param value the weekday value
 */
export const weekdayFromString = (value: string): Weekdays => {
  switch (value.toUpperCase()) {
    case 'MONTAG':
    case 'MONDAY':
      return Weekdays.MONDAY;
    case 'DIENSTAG':
    case 'TUESDAY':
      return Weekdays.TUESDAY;
    case 'MITTWOCH':
    case 'WEDNESDAY':
      return Weekdays.WEDNESDAY;
    case 'DONNERSTAG':
    case 'THURSDAY':
      return Weekdays.THURSDAY;
    case 'FREITAG':
    case 'FRIDAY':
      return Weekdays.FRIDAY;
    case 'SAMSTAG':
    case 'SATURDAY':
      return Weekdays.SATURDAY;
    case 'SONNTAG':
    case 'SUNDAY':
      return Weekdays.SUNDAY;
    default:
      throw new Error(`Illegal value: ${value.toUpperCase()}`);
  }
};

/**
 * Represents a Day as a number, where:
 * 1 = MONDAY
 * 2 = TUESDAY
 * 3 = WEDNESDAY
 * 4 = THURSDAY
 * 5 = FRIDAY
 * 6 = SATURDAY
 * 7 = SUNDAY
 */
export type Day = 1 | 2 | 3 | 4 | 5 | 6 | 7;

/**
 * Conversion helper to convert a weekday-number from date-fns into a Weekdays enum value.
 * e.g. getDay returns a number: 1 | 2 | 3 | 4 | 5 | 6 | 7 => where 7 = Sunday and 1 = Monday
 * @param weekday the weekday number returned by date-fns
 */
export const weekdayFromDay = (weekday: Day): Weekdays => {
  switch (weekday) {
    case 1:
      return Weekdays.MONDAY;
    case 2:
      return Weekdays.TUESDAY;
    case 3:
      return Weekdays.WEDNESDAY;
    case 4:
      return Weekdays.THURSDAY;
    case 5:
      return Weekdays.FRIDAY;
    case 6:
      return Weekdays.SATURDAY;
    case 7:
      return Weekdays.SUNDAY;
    default:
      throw new Error(`Illegal day: ${weekday}`);
  }
};

/**
 * Conversion helper to convert a Weekday enum value into a date-fns weekday value.
 * GetDay returns a number: 1 | 2 | 3 | 4 | 5 | 6 | 7 => where 7 = Sunday and 1 = Monday
 * @param weekday
 */
export const dayFromWeekday = (weekday: Weekdays): Day => {
  switch (weekday) {
    case Weekdays.MONDAY:
      return 1;
    case Weekdays.TUESDAY:
      return 2;
    case Weekdays.WEDNESDAY:
      return 3;
    case Weekdays.THURSDAY:
      return 4;
    case Weekdays.FRIDAY:
      return 5;
    case Weekdays.SATURDAY:
      return 6;
    case Weekdays.SUNDAY:
      return 7;
    default:
      throw new Error(`Illegal weekday: ${weekday}`);
  }
};
